import { Icon } from 'components/ui/general';

import { reactSelectComponents } from '../reactSelectComponents';

export const DropdownIndicator = (props: any) => {
  const { selectProps }: { [key: string]: any } = props;
  const { iconDropdownIndicator } = selectProps;

  if (iconDropdownIndicator)
    return (
      <reactSelectComponents.DropdownIndicator {...props}>
        <Icon name={iconDropdownIndicator} />
      </reactSelectComponents.DropdownIndicator>
    );

  return <reactSelectComponents.DropdownIndicator {...props} />;
};
